//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconMiscStepsAlt(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M21 5H12V7H21V5Z" fill="currentColor" /><path d="M17 11H8V13H17V11Z" fill="currentColor" /><path d="M12 17H3V19H12V17Z" fill="currentColor" /></svg>;
}
export default IconMiscStepsAlt;